export const attendanceHeading = [
    { name: "ID", width: 50 },
    { name: "Attendance Name", width: 50 },
    { name: "HOTEL", width: 50 },
    { name: "OUTLET", width: 50 },
    {name : "Action",width:70},
    {name : "Send/Download",width:70},
    {name: "Amend",width:50},
    {name:"Aprove",width:50}
  ];